
import Vue, { PropType } from 'vue';
import LessonCard from '@/components/cards/studyPlan/undergrad/LessonCard.vue';
import LiveCard from '@/components/cards/studyPlan/undergrad/LiveCard.vue';
import DateHeaderSkeleton from '@/components/skeletons/studyPlan/undergrad/DateHeaderSkeleton.vue';
import { Activity, ActivityType, DateActivities } from '@/models/kingslanding/studyPlanModel';

export default Vue.extend({
  components: {
    LessonCard,
    LiveCard,
    DateHeaderSkeleton,
  },
  props: {
    activitiesByDate: {
      required: true,
      type: Object as PropType<DateActivities>,
    },
  },
  computed: {
    activities(): Activity[] {
      return this.activitiesByDate?.activities || [];
    },
    activityDate(): string {
      return this.activitiesByDate?.date || '';
    },
  },
  methods: {
    getActivityComponent(activity: Activity) {
      switch (activity.type) {
        case ActivityType.lesson:
          return LessonCard;
        case ActivityType.live:
          return LiveCard;
        default:
          return undefined;
      }
    },
  },
});
